import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Spinner, InputGroup } from 'react-bootstrap';
import { useToast } from '../../../context/ToastContext';
import { useUser } from '../../../context/UserContext';
import logo_white from '../../../assets/images/logo_white.png';
import { apiSignIn } from '../../../api/api';

const SignIn = () => {
  const { addToast } = useToast();
  const { setUser } = useUser();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: '',
    email: ''
  });

  const validate = () => {
    const newErrors = [];
    if (!formData.email) newErrors.push('CPF/E-mail');
    if (!formData.password) newErrors.push('Senha');    
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (newErrors.length > 0) {
      var msg = newErrors.join(', ');
      addToast('Verifique os campos: ' + msg);
    } else {
      setLoading(true);
      try {
        var user = await apiSignIn(formData.email, formData.password);
        if (user) {
          setUser(user);
          navigate('/main');
        } else {
          addToast('Usuário e/ou senha inválidos!');
        }
      } catch (error) {
        addToast('Usuário ou senha inválidos!');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <Container fluid className='app-box-page d-flex flex-column justify-content-center vh-100'>
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <Container className='d-flex app-box-container'>
            <Row className='flex-grow-1'>
              <Col md={2} className='d-flex flex-column p-4 app-box-col-left'>
                <img src={logo_white} alt='' />
              </Col>
              <Col md={10} className='d-flex flex-column p-4 app-box-col-right'>
                <Form onKeyDown={handleKeyDown}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Usuário</Form.Label>
                    <Form.Control
                      name="email"
                      size="sm"
                      onChange={handleChange} />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formPass">
                    <Form.Label>Senha</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        size="sm"
                        onChange={handleChange} />
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? 'Ocultar' : 'Mostrar'}
                        </Button>
                      </InputGroup>
                  </Form.Group>
                </Form>
                <div className='d-flex justify-content-center'>
                  <Button onClick={handleSubmit} variant="primary" size="sm" className='me-1 w-25' disabled={loading}>
                    {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Entrar'}
                  </Button>
                  <Button onClick={handleBack} variant="secondary" size="sm" className='ms-1 w-25'>Voltar</Button>
                </div>
                <div className='text-center text-muted mt-4' style={{ fontSize: 'small' }}>
                  Esqueceu sua senha?<br />
                  <a href="recovery" >Recupere agora!</a>.
                </div>
                <div className='text-center text-muted mt-4' style={{ fontSize: 'small' }}>
                  <h5>Ainda não possui conta?</h5>
                  <h6><a href="sign-up" >Cadastre-se</a></h6>
                </div>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 6, offset: 3 }} className='text-center text-muted' style={{ fontSize: 'small' }}>CPUWEB | https://cpuweb.eastus.cloudapp.azure.com | 2025</Col>
      </Row>
    </Container>
  );
};

export default SignIn;